import { mapGetters, mapMutations } from 'vuex'
import cognitoService from '@/utils/cognito'

const GOOGLE_SCOPES = ['search-console', 'google-analytics', 'all']

export default {
  name: 'Auth',
  mounted () {
    const action = this.$route.params.action
    const token = this.$route.query.token
    const type = this.$route.query.type || ''
    const workspaceId = this.$route.query.workspaceId || ''
    const accessKey = this.$route.query.accessKey || ''
    const identityProvider = this.$route.query.identity_provider || ''
    const scope = this.$route.query.scope || ''
    const prompt = this.$route.query.prompt || ''
    const next = this.$route.query.next || window.location.origin + '/auth/in'

    if (action === 'in' && token) {
      this.setAuthToken(token)
      if (next && next !== window.location.origin + '/auth/in') {
        window.location.href = next
      } else {
        this.$router.push('/workspace')
      }
    } else if (action === 'out') {
      this.clearAllTokens()
      this.$router.push('/')
    } else if (scope && GOOGLE_SCOPES.includes(scope)) {
      // For Google OAuth scopes (GSC, GA), go directly to Google OAuth endpoint
      const encodedNext = encodeURIComponent(next + '?token=')
      let authUrl = `${this.apiUrl}/auth?next=${encodedNext}&scope=${scope}&workspaceId=${workspaceId}&accessKey=${accessKey}`
      if (prompt) authUrl += `&prompt=${prompt}`
      console.log('Redirecting to Google OAuth:', authUrl)
      window.location.href = authUrl
    } else {
      // For regular auth, use Cognito
      const encodedNext = encodeURIComponent(next + '?token=')
      let authUrl = `${this.apiUrl}/auth/cognito?next=${encodedNext}&type=${type}&workspaceId=${workspaceId}&accessKey=${accessKey}`
      if (identityProvider) authUrl += `&identity_provider=${identityProvider}`
      console.log('Redirecting to Cognito:', authUrl)
      window.location.href = authUrl
    }
  },
  computed: {
    ...mapGetters([
      'apiUrl'
    ])
  },
  methods: {
    ...mapMutations([
      'setAuthToken'
    ]),
    clearAllTokens () {
      // Clear app JWT
      this.setAuthToken()
      // Clear Cognito session
      cognitoService.signOut()
      // Clear any remaining Cognito tokens from localStorage
      const keysToRemove = Object.keys(localStorage).filter(key =>
        key.startsWith('CognitoIdentityServiceProvider') || key.startsWith('amplify')
      )
      keysToRemove.forEach(key => localStorage.removeItem(key))
    }
  }
}
